import { forwardRef } from 'react'
import logo from '../../icons/logo-RGB-71.png'
import { FullLogin, LoginContainer, Logo } from './style'

// eslint-disable-next-line react/display-name
const BaseLogin = forwardRef(({ children, onSubmit }, ref) => {
  return (
    <FullLogin>
      <Logo>
        <img src={logo} alt="logo" />
      </Logo>
      <LoginContainer ref={ref} onSubmit={onSubmit}>
        {children}
      </LoginContainer>

      <footer>Direitos reservados à Gestão do preço 2023</footer>
    </FullLogin>
  )
})

export default BaseLogin
